module.exports = __webpack_public_path__ + "img/video-page.e78198f4.png";